/*
 * Copyright (c) 2025.
 *  The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {SettingsResponse} from "types/responses/SettingsResponse";
import SettingsAction from "store/settings/SettingsAction";

export interface SettingsReducerSetSettingsAction {
    payload: SettingsResponse;
    type: typeof SettingsAction.SET_SETTINGS;
}

type SettingsReducerAction = SettingsReducerSetSettingsAction;

interface SettingsState extends SettingsResponse {}

class SettingsReducer {
    initialState: SettingsState = {
        config: null,
        languages: null,
        currencies: null,
        tickets: null,
        hall: null,
        liveSegments: null,
        speedLevels: null,
        powerUsers: null,
        trackLengths: null,
        permissions: null,
        permissionNames: [],
        permissionVisibleNames: [],
        displayAdvertisementTemplate: null,
    };

    reducer = (state: SettingsState = this.initialState, action: SettingsReducerAction): SettingsState => {
        switch (action.type) {
            case SettingsAction.SET_SETTINGS:
                return action.payload;
            default:
                return state;
        }
    };
}

export default SettingsReducer;
